import { useState } from "react";
import { Input } from "../../components/ui/Input";

/** The storefront's name for a guide left unnamed. */
const DEFAULT_LABEL = "Size guide";

type GuideLabelInputProps = {
	guideLabel: string | null;
	onCommit: (next: string | null) => void;
};

/**
 * A draft only while typing: the parent remounts this on a saved change, so a
 * refetch never leaves it showing a stale value.
 */
export const GuideLabelInput = ({ guideLabel, onCommit }: GuideLabelInputProps) => {
	const [value, setValue] = useState(guideLabel ?? "");

	return (
		<label className="block space-y-1.5">
			<span className="text-xs text-ink-muted">Button text</span>
			<Input
				value={value}
				onChange={(event) => setValue(event.target.value)}
				onBlur={() => {
					const next = value.trim() || null;
					if (next !== guideLabel) onCommit(next);
				}}
				onKeyDown={(event) => {
					if (event.key === "Enter") event.currentTarget.blur();
				}}
				maxLength={30}
				placeholder={DEFAULT_LABEL}
			/>
		</label>
	);
};
